import { cn } from '@/lib/utils'

/*
 * The two pieces of the Alumnia symbol (public/brand/encuentro/symbol-blue.svg),
 * with the right one moved 24 units out so the frame reads open. Together they
 * span x 16-160 and y 8-120 of the 176 x 128 box. `Cover` draws the same pieces.
 */
export const SYMBOL_LEFT = 'M16 112V64C16 30 40 8 72 8V38C56 38 46 49 46 66V112Z'
export const SYMBOL_RIGHT = 'M80 32C112 32 136 52 136 84V120H104V85C104 70 94 62 80 62Z'

/**
 * The Encuadre motif of Alumnia UI 1.2.1 (docs/redesign/sistema/EmptyState.md):
 * the two pieces of the symbol, opened, in `highlight`. It is the only
 * illustration of the system and it only goes on empty states. It is
 * decorative and it is not the logo, so it has no name and is never
 * recolored to the institution.
 */
export function EncuadreMotif({ className }: { className?: string }) {
  return (
    <svg
      data-slot="encuadre-motif"
      viewBox="0 0 176 128"
      aria-hidden="true"
      focusable="false"
      className={cn('h-16 w-22 shrink-0 fill-en-highlight', className)}
    >
      <path d={SYMBOL_LEFT} />
      <path d={SYMBOL_RIGHT} transform="translate(24 0)" />
    </svg>
  )
}
